import { useSyncExternalStore } from "react";
import { onlineManager } from "@tanstack/react-query";

/**
 * Whether the browser believes it has a network. Read from TanStack's
 * onlineManager, which is what pauses queries, so the banner and the data
 * layer can never disagree about being offline.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(
    (notify) => onlineManager.subscribe(notify),
    () => onlineManager.isOnline(),
    () => true,
  );
}
